import React from 'react';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';
import { Checkbox } from '../../../components/ui/Checkbox';

const FilterPanel = ({ filters, onFilterChange, onClearFilters, isOpen, onToggle }) => {
  const aiToolOptions = [
    { value: 'all', label: 'All Tools' },
    { value: 'chatgpt', label: 'ChatGPT' },
    { value: 'claude', label: 'Claude' },
    { value: 'midjourney', label: 'Midjourney' },
    { value: 'dalle', label: 'DALL-E' },
    { value: 'gemini', label: 'Gemini' },
    { value: 'copilot', label: 'GitHub Copilot' }
  ];

  const useCaseOptions = [
    { value: 'all', label: 'All Use Cases' },
    { value: 'content', label: 'Content Creation' },
    { value: 'marketing', label: 'Marketing' },
    { value: 'coding', label: 'Coding' },
    { value: 'design', label: 'Design' },
    { value: 'business', label: 'Business' },
    { value: 'education', label: 'Education' }
  ];

  const qualityOptions = [
    { value: 'all', label: 'All Quality Scores' },
    { value: '90', label: 'Excellent (90+)' },
    { value: '70', label: 'Good (70+)' },
    { value: '50', label: 'Fair (50+)' }
  ];

  return (
    <>
      {/* Mobile Filter Toggle */}
      <div className="lg:hidden mb-4">
        <Button
          variant="outline"
          iconName={isOpen ? "X" : "Filter"}
          iconPosition="left"
          onClick={onToggle}
          fullWidth
        >
          {isOpen ? 'Close Filters' : 'Show Filters'}
        </Button>
      </div>
      {/* Filter Panel */}
      <div className={`bg-card rounded-lg border border-border p-4 md:p-6 space-y-4 md:space-y-6 ${isOpen ? 'block' : 'hidden lg:block'}`}>
        <div className="flex items-center justify-between">
          <h3 className="text-lg font-semibold text-foreground">Filters</h3>
          <Button variant="ghost" size="sm" onClick={onClearFilters}>
            Clear All
          </Button>
        </div>

        <div className="space-y-4">
          <Input
            type="date"
            label="From Date"
            value={filters?.dateFrom}
            onChange={(e) => onFilterChange('dateFrom', e?.target?.value)}
          />

          <Input
            type="date"
            label="To Date"
            value={filters?.dateTo}
            onChange={(e) => onFilterChange('dateTo', e?.target?.value)}
          />

          <Select
            label="AI Tool"
            options={aiToolOptions}
            value={filters?.aiTool}
            onChange={(value) => onFilterChange('aiTool', value)}
          />

          <Select
            label="Use Case"
            options={useCaseOptions}
            value={filters?.useCase}
            onChange={(value) => onFilterChange('useCase', value)}
          />

          <Select
            label="Quality Score"
            options={qualityOptions}
            value={filters?.quality}
            onChange={(value) => onFilterChange('quality', value)}
          />

          <div className="pt-2">
            <Checkbox
              label="Show Favorites Only"
              checked={filters?.favoritesOnly}
              onChange={(e) => onFilterChange('favoritesOnly', e?.target?.checked)}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default FilterPanel;